// extracted by mini-css-extract-plugin
export default {"timeRemaining":"Timer_timeRemaining__xHPPf","red":"Timer_red__GjO5o"};